import { useState } from "react";
import { supabase } from "../../lib/supabase.js";

export default function Login() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const signIn = async () => {
    setBusy(true);
    setError(null);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: window.location.origin,
        queryParams: { prompt: "select_account" },
      },
    });
    if (error) {
      setError(error.message);
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-200 via-sky-50 to-cyan-100 px-6 relative overflow-hidden">
      <div aria-hidden="true" className="pointer-events-none absolute -top-40 -left-32 w-[520px] h-[520px] rounded-full bg-sky-400/30 blur-3xl" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-40 -right-32 w-[460px] h-[460px] rounded-full bg-cyan-300/35 blur-3xl" />
      <div aria-hidden="true" className="pointer-events-none absolute top-1/3 right-1/4 w-[280px] h-[280px] rounded-full bg-sky-500/15 blur-3xl" />
      <div className="relative z-10 w-full max-w-md bg-white rounded-2xl border border-stone-200 shadow-xl shadow-sky-900/5 p-10">
        <div className="flex items-center gap-3 mb-8">
          <img
            src="/linked_accounting_logo.png"
            alt="Linked Accounting LLP"
            className="h-10 w-auto"
          />
          <div className="text-xs uppercase tracking-widest text-stone-500 sans">
            Linked Accounting LLP
          </div>
        </div>

        <h1 className="serif text-3xl text-stone-900 mb-3">
          R&amp;D Study Workbench
        </h1>
        <p className="text-sm text-stone-700 leading-relaxed mb-2 sans">
          A workbench for firms running IRC §41 research credit studies.
          Built to scale with your engagement load — every figure on the
          schedule traces back to the documentation that supports it.
        </p>
        <p className="text-xs text-stone-500 mb-8 sans">
          Sign in with your firm Google account to continue.
        </p>

        <button
          onClick={signIn}
          disabled={busy}
          className="w-full flex items-center justify-center gap-3 px-5 py-3 rounded-lg border border-stone-300 bg-white hover:bg-stone-50 active:bg-stone-100 transition disabled:opacity-50 disabled:cursor-not-allowed sans text-sm font-medium text-stone-800"
        >
          <GoogleGlyph />
          {busy ? "Redirecting…" : "Continue with Google"}
        </button>

        {error && (
          <div className="mt-4 px-3 py-2 rounded-md bg-rose-50 border border-rose-200 text-rose-700 text-xs sans">
            {error}
          </div>
        )}

        <div className="mt-10 pt-6 border-t border-stone-100 text-xs text-stone-500 sans">
          Access is limited to approved firm staff. New users will see a
          pending-approval screen until an admin grants access.
        </div>
      </div>
    </div>
  );
}

function GoogleGlyph() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.997 8.997 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z"
      />
    </svg>
  );
}
